import type { MapGeometry } from "../shared/types";

/** Architectural ink stays on the floor, below even a zero-height booth roof. */
export const VENUE_MAP_ARCHITECTURE_HEIGHT = 0.018;
export const VENUE_MAP_ARCHITECTURE_COLOR = "#81908b";

const normalizedRings = new WeakMap<
  NonNullable<MapGeometry["architecture"]>,
  number[][][]
>();

/**
 * A single nonzero-fill path unions overlapping polygons like the GPU renderer.
 * Consistent outer/hole winding also keeps independent islands inside holes.
 * Normalize once per immutable outline instead of on every camera frame.
 */
export function venueMapArchitectureRings(
  architecture: NonNullable<MapGeometry["architecture"]>,
): number[][][] {
  const cached = normalizedRings.get(architecture);
  if (cached) return cached;
  const rings = architecture.flatMap((polygon) =>
    polygon.map((ring, index) => {
      const area = ring.reduce((sum, point, vertex) => {
        const next = ring[(vertex + 1) % ring.length];
        return sum + point[0] * next[1] - next[0] * point[1];
      }, 0);
      return area > 0 === (index === 0) ? ring : [...ring].reverse();
    }),
  );
  normalizedRings.set(architecture, rings);
  return rings;
}
